class FacetDrawer extends MainDrawer {
  constructor() {
    super();

    // this.trigger = this.querySelector('.drawer__trigger');
    // if (this.trigger) {
    //   this.trigger.addEventListener('click', () => {
    //     this.loadAssets();
    //     this.openDrawer()
    //   });
    // }

    // Load assets on page load
    //this.loadAssets();
  }

  loadAssets() {
    if (!document.getElementById('FACETSCSS') && !document.getElementById('FACETSJS')) {
      this.classList.add('loading');
    }
    loadCss('facets')
      .then(() => {
        this.classList.remove('loading');
        //console.log('facets css loaded');
      })
      .catch(error => {
        console.error(error);
      });
    loadScript('facets')
      .then(() => {
        //console.log('facets js loaded');
      })
      .catch(error => {
        console.error(error);
      });
  }
}

customElements.define('facet-drawer', FacetDrawer);

const getStatus = () => {
  const containers = document.querySelectorAll('.template-collection fieldset.size');
  
  containers.forEach(container => {
    const status = container.closest('.variant-options').querySelector('.variant-status');

    container.querySelectorAll('label').forEach(label => {
      label.addEventListener("mouseenter", () => {
        // Find the associated input for this label
        const inputId = label.getAttribute('for');
        const input = document.getElementById(inputId);
        if(input) {
          // Update the status text content with the input's data-status value
          status.textContent = input.dataset.status;
        }
      });
    });

    container.addEventListener("mouseleave", () => {
      status.textContent = 'Add to Bag';
    });
  });
};

getStatus();



// Switch product content on color swatch click
const getNewProduct = (event, route, el) => {  
  fetch(route).then((response) => {    
    return response.text();
  }).then((html) => {      
    const parser = new DOMParser();        
    const product =  parser.parseFromString(html, 'text/html').getElementById(el);          
        
    event.target.closest('.grid__item').id = product.id
    event.target.closest('product-form').replaceWith(product.querySelector('product-form'))    
    
    document.querySelectorAll(`#${product.id}`).forEach(el => {
      if(el.querySelector('.splide')){
        const splide = new Splide(el.querySelector('.splide'));       

        splide.on('mounted', function () {        
          const roles = document.querySelectorAll('.splide [role]');
                  
          roles.forEach(function (element) {
            element.removeAttribute('role');
          });
        });
        
        splide.mount();
      }      
    })
        
    getStatus()  
    
  }).catch((err) => {    
    console.warn('Something went wrong.', err);
  });  
}